'use client';

import { usePathname } from 'next/navigation';
import { useState, useEffect } from 'react';
import { NavigationBar } from '@/components/rendering/NavigationBar';
import { Leva } from 'leva';

interface RenderingLayoutProps {
  children: React.ReactNode;
}

export default function RenderingLayout({ children }: RenderingLayoutProps) {
  const pathname = usePathname();
  const [isMobile, setIsMobile] = useState(false);
  
  // 主页面不显示导航栏
  const showNavigation = pathname !== '/rendering';

  // 检测移动端屏幕尺寸
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="w-full h-screen relative">
      {/* 条件显示导航栏 - 仅子页面显示 */}
      {showNavigation && <NavigationBar />}
      
      {/* 子页面内容 - 确保充满剩余空间 */}
      <div className="w-full h-full">
        {children}
      </div>
      
      {/* Leva 全局配置 - 默认折叠面板，移动端隐藏 */}
      <Leva collapsed={true} hidden={isMobile} />
    </div>
  );
}